

























































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class MultiEditor extends Vue {
	@Prop()
	checked!: Assist.AccountData[];
	@Prop()
	employeeTypeList!: { id: string, text: string }[];
	@Prop()
	departList!: Assist.AccountData[];

	keys = [
		{ value: "state", label: "员工状态" },
		{ value: "phone", label: "手机号" },
		{ value: "dimDepartmentId", label: "所属部门" },
		{ value: "employType", label: "从业类型" },
		{ value: "startDate", label: "受雇日期" },
		{ value: "endDate", label: "离职日期" },
		{ value: "isSix", label: "六万扣除" },
	];

	form = {
		key: this.keys[0],
		value: ""
	}

	async onSubmit() {
		const ids: number[] = [];
		this.checked.forEach(v => {
			ids.push(v.id);
		});
		// if (this.form.value !== "") {
		// console.log(this.form, ids.join(","));
		const obj: any = { idStrs: ids.join(",") };
		obj[this.form.key.value] = this.form.value === null ? "" : this.form.value;
		// console.log(obj);
		await Vue.axios.post("dim/employeelist/modify", obj);
		this.$emit("success");
		// }
	}

	cancel() {
		this.$emit("cancel");
	}
}
